module.exports = __webpack_public_path__ + "img/27.a8e2f9a6.png";